import buildRequest from '../buildRequest';

// Endpoints
import { typesEndpoint } from '../../../common/types';

// Libs
import { axios } from '../../../lib/axios';

// Utils
import { dataResponse, handleError } from '../../../utils';

export const apiCrearRiesgoAsegurado = async params => {
  const url = typesEndpoint.postRiesgoAsegurado;

  const request = {
    ...params,
  };

  try {
    const { status, data } = await axios.post(url, request, buildRequest());
    return dataResponse({ data: data.resp, statusCode: status });
  } catch (error) {
    return handleError(error);
  }
};
